import conditions from './smFurtherAction/smConditions';
import states from './smFurtherAction/smStates';
import transitions from './smFurtherAction/transitions/default/smTransitions';
import GAtransitions from './smFurtherAction/transitions/ga/smTransitions';
import IDtransitions from './smFurtherAction/transitions/id/smTransitions';
import MNtransitions from './smFurtherAction/transitions/mn/smTransitions';
import NJtransitions from './smFurtherAction/transitions/nj/smTransitions';
import NMtransitions from './smFurtherAction/transitions/nm/smTransitions';
import NVtransitions from './smFurtherAction/transitions/nv/smTransitions';
import PAtransitions from './smFurtherAction/transitions/pa/smTransitions';
import VAtransitions from './smFurtherAction/transitions/va/smTransitions';
import ILtransitions from './smFurtherAction/transitions/il/smTransitions';
import { IEX_STATE_CODES } from '@constants/configs/states';

export default (state) => {
    // smConditions and smStates are shared across all states.
    // smTransitions are state specific.
    let result = {
        states: states,
        conditions: conditions
    };

    switch (state) {
        case IEX_STATE_CODES.ID: {
            result.transitions = IDtransitions;
            break;
        }
        case IEX_STATE_CODES.MN: {
            result.transitions = MNtransitions;
            break;
        }
        case IEX_STATE_CODES.GA:{
            result.transitions = GAtransitions;
            break;
        }
        case IEX_STATE_CODES.NM : {
            result.transitions = NMtransitions;
            break;
        }
        case IEX_STATE_CODES.NJ : {
            result.transitions = NJtransitions;
            break;
        }
        case IEX_STATE_CODES.PA : {
            result.transitions = PAtransitions;
            break;
        }
        case IEX_STATE_CODES.VA : {
            result.transitions = VAtransitions;
            break;
        }
        case IEX_STATE_CODES.NV:
        case IEX_STATE_CODES.GI:{
            result.transitions = NVtransitions;
            break;
        }
        case IEX_STATE_CODES.IL: {
            result.transitions = ILtransitions;
            break;
        }
        default: {
            result.transitions = transitions;
        }
    }

    return result;
};